import { Svg } from "../svg";
import { IconType } from "../../models";

export const IconFacebook: IconType = ({ className = "" }) => (
  <Svg className={className} viewBox="0 0 31 31">
    <circle
      cx="15.4827"
      cy="15.1152"
      r="14.25"
      stroke="#F8F7F6"
      stroke-width="1.5"
    />
    <path
      d="M13.2054 22.7898V14.7646H11.8428V12.38H13.2054V11.9755C13.2054 10.7193 13.5887 9.33536 14.5238 8.4837C15.3329 7.71722 16.4614 7.44043 17.3982 7.44043C18.1221 7.44043 18.6757 7.52559 19.1228 7.65334L18.995 10.1444C18.7199 10.0593 18.3776 9.99539 17.9534 9.99539C16.8888 9.99539 16.4417 10.8257 16.4417 11.8477V12.38H18.5266V14.7646H16.463V22.7898H13.2054Z"
      fill="#F8F7F6"
    />
  </Svg>
);
